var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconTlcActive = function SvgIconTlcActive(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-98 -322) translate(98 322)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#24C3CF",
    stroke: "#24C3CF"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.756,
    d: "M2.584.364C4.278.12 5.972 0 7.667 0c1.694 0 3.388.121 5.083.364 1.482.212 2.583 1.482 2.583 2.98v8.914c0 1.316-.855 2.48-2.111 2.873-1.852.58-3.704.869-5.555.869-1.852 0-3.704-.29-5.556-.869C.855 14.738 0 13.574 0 12.258V3.344C0 1.846 1.101.576 2.584.364z",
    transform: "translate(3 6)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.627,
    d: "M17.94 5.548l2.334-1.133c.934-.453 2.06-.064 2.514.871.117.243.182.507.188.777.016.662.024 1.33.024 2 0 .697-.009 1.388-.026 2.075-.026 1.039-.889 1.86-1.927 1.834-.254-.006-.505-.064-.736-.17l-2.285-1.044c-.625-.286-1.044-.893-1.089-1.58l-.005-.082c-.045-.688-.043-1.377.005-2.064.045-.639.428-1.205 1.004-1.484z",
    transform: "translate(3 6)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 9.5,
    r: 1.5,
    fill: "#FFF",
    fillOpacity: 0.4
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconTlcActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-tlc-active.69d6c500e1a66786e816e1dff3ee43e0.svg";